export default __webpack_public_path__ + "static/media/analysis-small.786bca4e.jpg";